import axios from 'axios'
import { resolveResponseData } from '@/services/helpers'
import { DEFAULT_NETWORK } from '@/store/modules/network/network'

const VALIDATOR_URL = DEFAULT_NETWORK.dcommGoUrl
/**
 * get current supply from Authority chain
 */

export async function getCurrentSupply() {
    return await axios
        .post(
            VALIDATOR_URL,
            JSON.stringify({
                jsonrpc: '2.0',
                method: 'authority.getCurrentSupply',
                params: {},
                id: 1,
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
        .then((res) => {
            return res.data.result
        })
}
